webpackJsonp([48],{

/***/ "1QOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// const shopname = 'senda';
var shopname = 'basto';
// const shopname = 'staccato';
// const shopname = 'teenmix';
// const shopname = 'bata';

// 测试   正式切换
// const version = 'ceshi-kaifa'
// const version = 'ceshi-fuwu'
// 正式
var version = 'shengchang';

var config = function config() {
  var shopnamechina = void 0;
  var brandNo = void 0;
  if (shopname == 'senda') {
    shopnamechina = '森达';
    brandNo = 'SD01';
  } else if (shopname == 'basto') {
    shopnamechina = '百思图';
    brandNo = 'BS01';
  } else if (shopname == 'staccato') {
    shopnamechina = '思加图';
    brandNo = 'ST01';
  } else if (shopname == 'teenmix') {
    shopnamechina = '天美意';
    brandNo = 'TM01';
  } else if (shopname == 'bata') {
    shopnamechina = '拔佳';
    brandNo = 'BT01';
  }
  if (version == 'ceshi-kaifa' || version == 'ceshi-fuwu') {
    var routerapi = void 0;
    if (version == 'ceshi-kaifa') {
      // routerapi = 'http://custom-mall-api-test.epoque.cn/v1/wechat/epoque'
      routerapi = 'http://custom-mall-api-test.epoque.cn/v1/wechat/oauth/entrance';
    } else if (version == 'ceshi-fuwu') {
      routerapi = 'http://custom-mall-api-test.epoque.cn/v1/wechat/oauth/entrance';
    }
    return {
      routerapi: routerapi,
      vouchernoApi: 'http://119.23.59.31:8091/',
      domainname: 'http://custom-mall-' + shopname + '-test.epoque.cn',
      router: 'http://custom-mall-api-test.epoque.cn',
      shopname: shopname,
      shopnamechina: shopnamechina,
      brandNo: brandNo,
      registeraddress: '&test=123',
      // payurl:"http://custom-mall-test.epoque.cn", // 测试不可付款
      payurl: "http://custom-mall.epoque.cn", // 生产不可付款
      version: version
      // registeraddress: '',
    };
  }
  return {
    vouchernoApi: 'http://office.epoque.cn/api-v1.0/',
    domainname: 'http://custom-mall-' + shopname + '.epoque.cn',
    router: 'http://custom-mall-api.epoque.cn',
    routerapi: 'http://custom-mall-api.epoque.cn/v1/wechat/oauth/entrance',
    shopname: shopname,
    shopnamechina: shopnamechina,
    brandNo: brandNo,
    registeraddress: '',
    payurl: "http://custom-mall.epoque.cn",
    version: version
  };
};

/* harmony default export */ __webpack_exports__["a"] = (config());

// import config from '@/conf'
// `${config.maincolor}`

/***/ }),

/***/ "JdF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/weixin-js-sdk/index.js
var weixin_js_sdk = __webpack_require__("fxnj");
var weixin_js_sdk_default = /*#__PURE__*/__webpack_require__.n(weixin_js_sdk);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/conf/index.js
var conf = __webpack_require__("1QOn");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/loads.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var loads = ({
    data: function data() {
        return {
            configin: null // config的映射
        };
    },

    props: {
        titleInfo: {
            type: String
        }
    },
    watch: {},
    mounted: function mounted() {
        this.configin = conf["a" /* default */];
    },

    methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2158c496","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loads.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.configin && _vm.$store.state.storeforload)?_c('div',{staticClass:"loading"},[(_vm.configin.shopname == 'senda')?_c('div',{staticClass:"senda loading-brand"},[_c('span',[_vm._v("S")]),_vm._v(" "),_c('span',[_vm._v("E")]),_vm._v(" "),_c('span',[_vm._v("N")]),_vm._v(" "),_c('span',[_vm._v("D")]),_vm._v(" "),_c('span',[_vm._v("A")])]):_vm._e(),_vm._v(" "),(_vm.configin.shopname == 'basto')?_c('div',{staticClass:"basto loading-brand"},[_c('span',[_vm._v("B")]),_vm._v(" "),_c('span',[_vm._v("A")]),_vm._v(" "),_c('span',[_vm._v("S")]),_vm._v(" "),_c('span',[_vm._v("T")]),_vm._v(" "),_c('span',[_vm._v("O")])]):_vm._e(),_vm._v(" "),(_vm.configin.shopname == 'staccato')?_c('div',{staticClass:"staccato loading-brand"},[_c('span',[_vm._v("S")]),_vm._v(" "),_c('span',[_vm._v("T")]),_vm._v(" "),_c('span',[_vm._v("A")]),_vm._v(" "),_c('span',[_vm._v("C")]),_vm._v(" "),_c('span',[_vm._v("C")]),_vm._v(" "),_c('span',[_vm._v("A")]),_vm._v(" "),_c('span',[_vm._v("T")]),_vm._v(" "),_c('span',[_vm._v("O")])]):_vm._e(),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"foottext"},[_vm._v("请求数据...")])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-tips"},[_c('span',{staticClass:"loading-text-words"},[_vm._v("科")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("技")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("·")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("舒")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("适")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("·")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("匠")]),_vm._v(" "),_c('span',{staticClass:"loading-text-words"},[_vm._v("心")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_loads = (esExports);
// CONCATENATED MODULE: ./src/components/common/loads.vue
function injectStyle (ssrContext) {
  __webpack_require__("JdF+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2158c496"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  loads,
  common_loads,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_loads = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//





/* harmony default export */ var App = ({
  name: 'app',
  data: function data() {
    return {
      wxconfig: {
        appId: "",
        timestamp: "",
        nonceStr: "",
        signature: ""
      },
      locationUrl: "",
      shareUrl: "",
      shareTitle: conf["a" /* default */].shopnamechina + '\u5B9A\u5236\u5546\u57CE', // 分享标题
      shareDesc: '舒适不将就，为你定制专属鞋款！', // 分享描述
      shareImgUrl: conf["a" /* default */].domainname + '/static/img/' + conf["a" /* default */].shopname + '_logo.png' // 分享图标
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  components: {
    loads: components_common_loads
  },
  methods: {
    getweinsdkinfo: function getweinsdkinfo() {
      var self = this;
      axios_default.a.post('/v1/js.conf', {
        url: self.locationUrl
      }).then(function (res) {
        self.wxconfig.appId = res.data.data.appId;
        self.wxconfig.timestamp = res.data.data.timestamp;
        self.wxconfig.nonceStr = res.data.data.nonceStr;
        self.wxconfig.signature = res.data.data.signature;
        self.init();
      }).catch(function (error) {});
    },
    init: function init() {
      var self = this;
      weixin_js_sdk_default.a.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: self.wxconfig.appId, // 必填，公众号的唯一标识
        timestamp: self.wxconfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: self.wxconfig.nonceStr, // 必填，生成签名的随机串
        signature: self.wxconfig.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'scanQRCode'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      weixin_js_sdk_default.a.ready(function () {
        //分享到朋友圈
        weixin_js_sdk_default.a.onMenuShareTimeline({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          success: function success() {
            // 用户确认分享后执行的回调函数
          },
          cancel: function cancel() {
            // 用户取消分享后执行的回调函数
          }
        });
        //分享给朋友
        weixin_js_sdk_default.a.onMenuShareAppMessage({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function success() {
            // 用户确认分享后执行的回调函数
            // alert('link -- ' + self.shareUrl)
            // alert('shopnamechina -- ' + config.shopnamechina)
            // alert('domainname -- ' + config.domainname)
          },
          cancel: function cancel() {
            // 用户取消分享后执行的回调函数
            // alert('取消分享')
          },
          catch: function _catch() {
            alert('catch');
          },
          error: function error() {
            alert('error');
          }
        });
        //分享到QQ
        weixin_js_sdk_default.a.onMenuShareQQ({
          title: self.shareTitle, // 分享标题
          desc: self.shareDesc, // 分享描述
          link: self.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: self.shareImgUrl, // 分享图标
          success: function success() {
            // 用户确认分享后执行的回调函数
          },
          cancel: function cancel() {
            // 用户取消分享后执行的回调函数
          }
        });
      });
      weixin_js_sdk_default.a.error(function (res) {
        if (!/-test/.test(document.URL) && /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
          location.reload();
        }
        // location.reload(); //ios首次进入signature失效
      });
      weixin_js_sdk_default.a.checkJsApi({
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'scanQRCode'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function success(res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          self.$store.state.isscan = true;
        },
        cancel: function cancel(err) {
          alert('jsApiList错误');
          alert(err);
        }
      });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // console.log('触发路由监听了')
      //新用戶進來的時候  仅仅在第一次的时候回去appid，signature等四个值
      //刷新当前页面的时候 sendaToken是存在的 但是appid，signature等四个值是没有存在sessionStroge中，要重新获取
      //每切换一个页面都要重新注册分享地址，应为分享出去的地址是不一样的
      //分享地址规则   产品页面分享地址是产品页面   其他页面分享出去都是首页
      var self = this;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        self.locationUrl = location.href;
      }
      if (isIOS) {
        self.locationUrl = location.href.split('#')[0]; //hash后面的部分如果带上ios中config会不对
      }
      // if(location.href.indexOf("commoditydetail")>-1){ // 在店和高端合并前
      if (to.path.indexOf("detailsofthebnedition") > -1) {
        self.shareUrl = location.href.replace(/\/detailsofthebnedition\/.*?\?/, '/detailsofthebnedition?');
      } else if (to.path == '/coupondetailr' || to.path == '/couponReceive') {
        // 请求的
        var showName = encodeURI(to.query.showName);
        if (!to.query.couponType) {
          self.shareUrl = conf["a" /* default */].domainname + '/#/couponReceive?recordId=' + to.query.recordId + '&showName=' + showName + '&parValue=' + to.query.parValue + '&couponType=3';
          self.shareTitle = '\u9001\u4F60\u4E00\u5F20' + (to.query.parValue - 0) + '\u5143' + decodeURI(showName);
        } else {
          self.shareUrl = conf["a" /* default */].domainname + '/#/couponReceive?recordId=' + to.query.recordId + '&showName=' + showName + '&parValue=' + to.query.parValue;
          self.shareTitle = '\u9001\u4F60\u4E00\u5F20' + (to.query.parValue - 0) / 10 + '\u6298' + decodeURI(showName);
        }
      } else {
        self.shareUrl = '' + conf["a" /* default */].domainname;
      }
      // alert('self.shareUrl-router --- ' + self.shareUrl)
      if (localStorage.getItem('epoqueToken') && sessionStorage.getItem('epoqueToken') != '') {
        this.getweinsdkinfo();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c7b5402","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('loads'),_vm._v(" "),_c('router-view')],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./src/router/index.js + 3 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./src/vuex/state.js
var state = __webpack_require__("yalW");

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// CONCATENATED MODULE: ./src/main.js

__webpack_require__("bfxE");







axios_default.a.defaults.baseURL = '' + conf["a" /* default */].router;
axios_default.a.interceptors.request.use(function (config) {
  //发送请求前将token带到后端
  if (localStorage.epoqueToken) {
    config.headers['X-epoque-mall-Authorization'] = JSON.parse(localStorage.epoqueToken).content;
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return promise_default.a.reject(error);
});
axios_default.a.interceptors.response.use(function (response) {
  // 响应失败
  if (response.data.error_code && (response.data.error_code == 10001 || response.data.error_code == 10002)) {
    localStorage.removeItem('epoqueToken'); //新加的
    location.reload(true);
  }
  return response;
}, function (error) {
  // 对响应错误做点什么
  return promise_default.a.reject(error);
});
// 全局引入vue-awesome-swiper
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper)
// import 'swiper/dist/css/swiper.css'

//全局引入vue-lazyload

vue_esm["a" /* default */].use(vue_lazyload_default.a, {
  preLoad: 1.3,
  error: './static/img/lazyload_fail.png',
  loading: './static/img/lazyload.png',
  attempt: 1
});

vue_esm["a" /* default */].config.productionTip = false;
// 全局引入vue-swipe
// import { Swipe, SwipeItem } from 'vue-swipe';
// Vue.component('swipe', Swipe);
// Vue.component('swipe-item', SwipeItem);

var vm = new vue_esm["a" /* default */]({
  el: '#app',
  router: router["a" /* default */],
  store: state["a" /* default */],
  template: '<App/>',
  components: { App: src_App },
  methods: {},
  created: function created() {}
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/vuex/state.js
var state = __webpack_require__("yalW");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/transfer.vue
//
//
//
//
//
//



/* harmony default export */ var transfer = ({
  name: 'transfer',
  data: function data() {
    return {
      membersign: '',
      referer: ''
    };
  },
  created: function created() {
    var self = this;
    var urlparam = self.$route.query;
    self.membersign = urlparam.membersign;
  },
  mounted: function mounted() {
    this.gettoken();
  },

  methods: {
    gettoken: function gettoken() {
      var self = this;
      axios_default.a.post('/v1/user/token/get', lib_default.a.stringify({
        member_sign: self.membersign
      })).then(function (res) {
        var bastoToken = res.data.token;
        sessionStorage.setItem('bastoToken', bastoToken);
        self.$store.state.isnew = res.data.is_new;
        self.$store.state.islogin = res.data.is_new;
        self.$store.state.referer = res.data.referer;
        if (res.data.referer == '') {
          self.referer = "/";
        } else {
          self.referer = res.data.referer;
        }
        //去掉地址中的时间戳
        // alert('location.href=to == ' + `${location.protocol+'//'+location.host+'/#'+self.referer}`)
        location.href = location.protocol + '//' + location.host + '/#' + self.referer;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getuserinfo: function getuserinfo() {
      var self = this;
      axios_default.a.post('/v1/user/clear').then(function (res) {
        console.log(res.data);
        if (res.data.result == 'success') {
          location.href = location.protocol + '//' + location.host + '/#' + self.referer;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {
    referer: function referer() {
      //this.getuserinfo();
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1227dbfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/transfer.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_transfer = (esExports);
// CONCATENATED MODULE: ./src/components/common/transfer.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  transfer,
  common_transfer,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_transfer = (Component.exports);

// EXTERNAL MODULE: ./src/conf/index.js
var conf = __webpack_require__("1QOn");

// CONCATENATED MODULE: ./src/router/index.js




// 中转组件




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
var router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/productindex',
    name: 'productindex',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iVAe")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '' + conf["a" /* default */].shopnamechina + '定制商城'
    }
  },
  //路由重定向
  {
    path: '/',
    redirect: '/productindex'
  }, {
    path: '/search',
    name: 'search',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("X5uk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '个人中心'
    }
  },
  // 中转路由
  {
    path: '/transfer',
    name: 'transfer',
    component: components_common_transfer,
    replace: true
  }, {
    path: '/person_center',
    name: 'person_center',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UDoS")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '个人中心'
    }
  }, {
    path: '/listSearch',
    name: 'listSearch',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("z10w")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '搜索列表'
    }
  }, {
    path: '/collect',
    name: 'collect',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wQdw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '我的收藏'
    }
  }, {
    path: '/submitorder',
    name: 'submitorder',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9mge")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '提交订单'
    }
  }, {
    path: '/orderdetail',
    name: 'orderdetail',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2yPk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/commoditydetail',
    name: 'commoditydetail',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("if66")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '商品详情'
    }
  }, {
    path: '/detailsofthebnedition',
    name: 'detailsofthebnedition',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("X7HV")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '商品详情'
    },
    children: [{
      path: '',
      name: 'detailCouponNull',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("riEQ")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: 'detailCoupon',
      name: 'detailCoupon',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PEg2")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: 'detailSku',
      name: 'detailSku',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nUX0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }, {
    path: '/subordbnedition',
    name: 'subordbnedition',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DdIi")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '提交订单'
    },
    children: [{
      path: 'preferenceAcquisition',
      name: 'preferenceAcquisition',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("45HA")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }, {
    path: '/addresslist',
    name: 'addresslist',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mnwi")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '地址列表'
    }
  }, {
    path: '/editaddress/:id',
    name: 'editaddress',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AqRF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '编辑地址'
    }
  }, {
    path: '/customexplain',
    name: 'customexplain',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/GAm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '定制说明'
    }
  }, {
    path: '/paystatus',
    name: 'paystatus',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dIco")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '支付结果'
    }
  }, {
    path: '/paystatusinshop',
    name: 'paystatusinshop',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("h4C0")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '支付状态'
    }
  }, {
    path: '/productlist',
    name: 'productlist',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P3/l")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '商品列表'
    }
  }, {
    path: '/passportlist',
    name: 'passport_list',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("22R+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '报告列表'
    }
  }, {
    path: '/passportdetail/:center/:uuid',
    name: 'passportdetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XEcb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '报告详情'
    }
  }, {
    path: '/passportdetail',
    name: 'passport_detail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XEcb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    // props: true,
    meta: {
      title: '报告详情'
    }
  }, {
    path: '/data_validation',
    name: 'data_validation',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZnWL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '足型数据确认'
    }
  }, {
    path: '/footcomfir',
    name: 'footcomfir',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vVQF")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '确认报告'
    }
  }, {
    path: '/personaldata',
    name: 'personal_data',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ql1G")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '修改资料'
    }
  }, {
    path: '/coupon/:type',
    name: 'coupon',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d6N+")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '优惠劵'
    }
  }, {
    path: '/orderlist',
    name: 'orderlist',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3qvc")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '我的订单'
    }
  }, {
    path: '/orderdelivery',
    name: 'orderdelivery',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1bYt")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '订单跟踪'
    }
  }, {
    path: '/verify',
    name: 'verify',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(46)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Y+Hx")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '验证手机号'
    }
  }, {
    path: '/coupondetail',
    name: 'coupon_detail',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mPh3")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '优惠劵详情'
    }
  }, {
    path: '/coupondetailr',
    name: 'coupon_detail_r',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(38)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fswn")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '优惠券详情'
    }
  }, {
    path: '/couponReceive',
    name: 'couponReceive',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Pe7l")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true,
    meta: {
      title: '领取优惠券'
    }
  },
  /*订单*/
  // 订单列表
  // 订单详情
  // 订单评价
  {
    path: '/orderevaluate',
    name: 'orderevaluate',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bdxw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '订单评价'
    }
  },
  /*售后*/
  //售后生成
  {
    path: '/saleservicegenerate',
    name: 'saleservicegenerate',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iDHa")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后'
    }
  },
  //售后政策
  {
    path: '/saleservicepolicy',
    name: 'saleservicepolicy',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(33)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ABfy")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后政策'
    }
  },
  // 售后列表
  {
    path: '/saleservicelist',
    name: 'saleservicelist',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jdZq")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后列表'
    }
  },
  // 售后详情
  {
    path: '/saleserviceinfo',
    name: 'saleserviceinfo',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sPNh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后详情'
    }
  },

  //售后审核成功
  {
    path: '/saleservicesuccess',
    name: 'saleservicesuccess',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("C+eb")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后审核成功'
    }
  },
  // 审核失败
  {
    path: '/saleservicefail',
    name: 'saleservicefail',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(42)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+LH8")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后审核失败'
    }
  },
  //售后关闭
  {
    path: '/saleserviceclose',
    name: 'saleserviceclose',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GK03")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后关闭'
    }
  },

  //物流
  {
    path: '/saleservicelogistics',
    name: 'saleservicelogistics',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ScLh")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '物流'
    }
  },
  //工厂已收货
  {
    path: '/saleservicereceive',
    name: 'saleservicereceive',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8N0P")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后'
    }
  },
  //售后退款
  {
    path: '/saleservicerefund',
    name: 'saleservicerefund',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c78b")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '售后退款'
    }
  },
  //下拉加载测试
  {
    path: '/list',
    name: 'list',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(44)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eP2p")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  },
  //小编推荐
  {
    path: '/article',
    name: 'article',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(45)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QgFn")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '小编推荐'
    }
  },
  // 活动专题页
  {
    path: '/activity',
    name: 'activity',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("deAk")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '活动专题页'
    }
  }, {
    path: '/getticket',
    name: 'getticket',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LK+I")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      title: '券提取页'
    }
  },
  // 失效页面
  {
    path: '/pageFailure',
    name: 'pageFailure',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("U48C")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(function (to, from, next) {
  /* const bastoToken = sessionStorage.getItem('bastoToken');
  if(to.name == 'transfer'){
    if(bastoToken && (bastoToken != '' && (bastoToken != null))){
      next(false);
      history.go(-3);
    }else{
      next();
    }
  }else{
    if(bastoToken && (bastoToken != '' && (bastoToken != null))){
      next();
    }else{
      if(window.location.href.indexOf('?membersign=') == -1){
        var transferUrl = encodeURIComponent(location.origin+"/@/transfer");
        var refererUrl = encodeURIComponent(to.fullPath);
        // var refererUrl = encodeURIComponent(location.href);
        //EP小助手的跳转地址  用意礴登录不用修改地址
        // location.href = `http://custom-mall-api-test.epoque.cn/v1/wechat/epoque/entrance?transfer=${transferUrl}&referer=${refererUrl}`;
        // location.href = `http://custom-mall-api-test.epoque.cn/v1/wechat/senda/entrance?transfer=${transferUrl}&referer=${refererUrl}`;
        //生产的跳转地址   用森达登录不用修改地址
        // location.href = `http://custom-mall-api.epoque.cn/v1/wechat/senda/entrance?transfer=${transferUrl}&referer=${refererUrl}`;
        //所有商城统一用epoque授权
        // 这里使用了test=123，调用的是意礴的注册接口，这里仅供测试环境使用，切不能支付
        // location.href = `${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}&test=123`;
        location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}${config.registeraddress}`);
          // 不同的商城用自己的授权
        // location.href = `${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`;
        next(false);
      }else{
        next();
      }
    }
  }*/
  // window.localStorage.removeItem("sendaToken");
  if (to.name == 'transfer') {
    if (localStorage.epoqueToken) {
      next(false);
      history.go(-4);
    } else {
      var referer;
      axios_default.a.post('/v1/user/token/get', {
        member_sign: to.query.membersign
      }).then(function (res) {
        var token = res.data.token;
        //新获取的token  7天后过期
        var expiredTime = new Date().getTime() + 25200000,

        // const expiredTime = new Date().getTime()+300000,
        epoqueToken = { "content": token, "expiredTime": expiredTime };
        localStorage.setItem("epoqueToken", stringify_default()(epoqueToken));
        state["a" /* default */].state.islogin = res.data.is_new;
        state["a" /* default */].state.referer = res.data.referer;
        if (res.data.referer == '') {
          referer = "/";
        } else {
          referer = res.data.referer;
        }
        //去掉重定向后的时间戳
        location.replace(location.protocol + '//' + location.host + '/#' + referer);
      }).catch(function (error) {
        console.log(error);
      });
    }
  } else {
    if (localStorage.epoqueToken) {
      try {
        JSON.parse(localStorage.epoqueToken).content;
      } catch (err) {
        window.localStorage.removeItem("epoqueToken");
        location.reload();
      }
      var currentTime = new Date().getTime(),
          epoqueToken = JSON.parse(localStorage.epoqueToken);
      if (epoqueToken.expiredTime - currentTime < 0 && state["a" /* default */].state.loginfirst) {
        //删除token
        localStorage.removeItem("epoqueToken");
        //重新获取token
        setTimeout(function () {
          var transferUrl = encodeURI(location.origin + "/@/transfer");
          var refererUrl = encodeURIComponent(to.fullPath);
          window.location.replace(conf["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
        }, 100);
      } else {
        // store.state.loginfirst = false;
        if (state["a" /* default */].state.loginfirst) {
          axios_default.a.post('/v1/user/update/status').then(function (res) {
            if (res.data.code && res.data.code == 200) {
              state["a" /* default */].state.loginfirst = false;
              next();
            } else {
              // location.reload()
              setTimeout(function () {
                var transferUrl = encodeURI(location.origin + "/@/transfer");
                var refererUrl = encodeURIComponent(to.fullPath);
                window.location.replace(conf["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl);
              }, 100);
            }
          });
        } else {
          next();
        }
      }
    } else {
      if (window.location.href.indexOf('?membersign=') == -1) {
        setTimeout(function () {
          var transferUrl = encodeURI(location.origin + "/@/transfer");
          var refererUrl = encodeURIComponent(to.fullPath);
          // window.location.replace(`${config.routerapi}?transfer=${transferUrl}&referer=${refererUrl}`);
          location.replace(conf["a" /* default */].routerapi + '?transfer=' + transferUrl + '&referer=' + refererUrl + conf["a" /* default */].registeraddress);
        }, 100);
      } else {
        next();
      }
    }
  }
});

router.afterEach(function (route) {
  // 从路由的元信息中获取 title 属性
  if (route.meta.title) {
    document.title = route.meta.title;
    // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      var hackIframe = document.createElement('iframe');
      hackIframe.style.display = 'none';
      document.body.appendChild(hackIframe);
      setTimeout(function (_) {
        document.body.removeChild(hackIframe);
      }, 300);
    }
  }
});
/* harmony default export */ var src_router = __webpack_exports__["a"] = (router);

/***/ }),

/***/ "bfxE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yalW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


var _state;



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);
var state = (_state = {
  uuid: '', //商品详情页面的uuid
  center: 0, //锦泉要的center
  sale_price: '', //鞋子的售价
  is_Edit: false, //是否制作了鞋子
  product_id: '', //产品ID
  // product_name:'',//产品名称
  // product_tag:'',//产品标签
  ftdconfir: false, //是否确认脚型数据
  explaincon: false, //商品详情页的《定制说明》
  explain: false, //提交订单页的《定制说明》
  agree_explain: false, //提交订单页的同意勾选框
  customized: {}, //定制参数
  // base_image:'',//线装图
  whiteimage: '', //线装图辅助图
  // merge_img:'',//定制帮面图数组
  passport: false, //足型报告弹出层
  custom: [], //定制参数，，，
  hasdefautaddress: false, //是否有默认地址
  defautaddress: false, //默认地址
  comfirmpass: false, //是否确认脚型数据（从接口返回的）
  business_shoes_size: null, // 下单页 用户编辑穿鞋尺码
  shoes_preference: null, // 下单页 用户编辑穿鞋偏好
  preference_desc: null, // 下单页 用户编辑穿鞋痛点


  /* 锦泉 */
  passportlistenteruuid: '',
  itemcenter: 0,
  address: {},
  centeraddress: 0,
  choisaddress: false,
  coupon: '',
  coupons: [],
  choiscoupon: false, // 是否选择了券
  ischangecoupon: false, // 是否修改了优惠券
  commoditydetailurl: null,
  tomap: false,
  istomap: 0,
  istomap2: 0,
  hasaddress: true,
  tomapstate: false,
  selectcoupon: {}, // coupon.vue里存放选中的优惠券
  orderamount: null,
  newchoiscoupon: [], //选中的劵
  couponprise: null, //折后价
  newaddress: false, // 是否是新增地址
  setA: false, // 阻止新增地址的第二次回退
  isDoubt: false, //
  editrefresh: false }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'product_id', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'showbuttom', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'storeforload', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'comSelecParameters', {
  base_image: '', //线装图
  product_name: '', //产品名称
  product_tag: '', //产品标签
  bnintrodarrvalue: '', //宽窄版的选择值key
  size_pool_num: '', //宽窄版选择的尺码
  modeissize: 0 // 类型1是在店定制0为高端定制
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'detailApiDetails', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'articleApiDetails', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'getticketApiDetails', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'toListRouter', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'exclusiveItem', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'recommendScore', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'includedComponents', ['productindexnull', 'productlist', 'search', 'listSearch']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'excludedComponents', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'couponReceiveShowName', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'couponReceiveParValue', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'showreceive', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'openpurchase', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'detailCouponScrollT', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'showToCouponType', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'loginfirst', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'islogin', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'shopname', "意礴定制商城"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'referer', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'sex', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'categoryId', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'tagId', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'num', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'linkway', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'applyreason', ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'saleserviceimg', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'scrollx', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'scrolly', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'popupwindow', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'scrolltoplisttodetail', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'xx', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'searchClassificationConfCate', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'includedComponentsSearch', ['search']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'excludedComponentsSearch', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'useDiscountType', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'transmitInformationParms', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_state, 'normalPay', null), _state);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state
}));

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3df328207297675b6106.js